import $ from "jquery";
import Toastify from "toastify-js";
import { jobFiles } from "./add-job-modal.js";
import { Modal } from "bootstrap";
import * as FilePond from "filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageEdit from "filepond-plugin-image-edit";

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css";

FilePond.registerPlugin(FilePondPluginFileValidateType);
FilePond.registerPlugin(FilePondPluginImageExifOrientation);
FilePond.registerPlugin(FilePondPluginImagePreview);
FilePond.registerPlugin(FilePondPluginImageEdit);

export var jobExamples = [];
let allExamples = [];

/** ✅ только для добавления/удаления фото */
let examplePhotos = [];

const workshopId = $("#workshop_id").val();
const isEditPage = location.href.includes("edit");

if (
  location.href.includes("workshop/edit") ||
  location.href.includes("workshop/my")
) {
  // Инициализация модалки удаления
  const deleteExamplesModal = document.getElementById("deleteModal");
  let deleteModal = deleteExamplesModal ? new Modal(deleteExamplesModal) : null;
  let deleteId = null;

  // Загрузка примеров с бэка
  async function getWorkshopExamples() {
    $.getJSON(`/api/examples?workshop_id=${workshopId}`, function (data) {
      console.log(data);
      allExamples = data?.result?.data ?? [];
      // renderJobExamples(allExamples);
    });
  }

  getWorkshopExamples();

  // Рендер карточек
  function renderJobExamples(examples) {
    const examplesList = $(".examples__list");
    $(".examples__list .example__list-card").remove();
    // examplesList.html("");

    examples?.forEach((item, index) => {
      let files = item.files;
      let firstFile = null;

      if (typeof files === "string" || !files[0]?.file) {
        try {
          const parsed = JSON.parse(files);
          if (parsed?.result?.length > 0) {
            files = parsed.result;
            firstFile = "/upload/zakaz/" + parsed.result[0];
          }
        } catch (e) {
          // ignore parse errors
        }
      } else {
        firstFile = URL.createObjectURL(files[0].file);
      }
      const imgSrc = firstFile ?? null;
      const priceText = item.price ? `${item.price} ₽` : "Цена не указана";

      const safeImages = encodeURIComponent(JSON.stringify(files || []));

      const imageHTML = imgSrc
        ? `<img src="${imgSrc}" class="card-img-top" alt="${item.name}">`
        : `<div class="d-flex align-items-center justify-content-center bg-light" style="height: 160px;">Нет фото</div>`;

      const buttonsHTML = isEditPage
        ? `<div class="examples__actions flex gap-md align-items-center mt-2">
                <button type="button"
                        class="edit-example-btn"
                        data-id="${item.id}"
                        data-bs-toggle="modal"
                        data-bs-target="#editJob"
                        title="Редактировать">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-pencil"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /></svg>
                </button>
                <button type="button" data-name="${item.name}" data-id="${item.id}"
                    class="delete-example-btn fs-4" data-index="${index}">
                    <svg data-id="5" class="response__remove-trigger cursor-pointer btn-delete-review" data-bs-toggle="modal" data-bs-target="#deleteReviewModal" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M4 7l16 0"></path>
                        <path d="M10 11l0 6"></path>
                        <path d="M14 11l0 6"></path>
                        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                    </svg>
                </button>
              </div>`
        : "";

      const newHTML = `
      <div data-bs-toggle="modal" data-bs-target="#exampleModal" class="col mb-3 example__list-card cursor-pointer" data-id="${
        item.id
      }" data-name="${item.name || ""}" data-description="${
        item.description || ""
      }"
        data-price="${item.price || ""}"
        data-images="${safeImages}">
        <div class="h-100 position-relative" data-example-id="${item.id}">
        ${imageHTML}
            <div class="card-body d-flex flex-column">
                <h6 class="card-title text-truncate" title="${item.name}">
                    ${item.name}
                </h6>
                <p class="card-text mb-2">${priceText}</p>
            </div>
            ${buttonsHTML}
        </div>
    </div>
    `;
      examplesList.prepend(newHTML);
    });
  }

  // Открытие модалки удаления
  function openDeleteModal() {
    deleteId = $(this).data("id");
    console.log($(this), this);
    const name = $(this).data("name");

    // Если пример ещё не сохранён на сервер, удаляем сразу
    if (jobExamples.find((item) => item.id === deleteId)) {
      jobExamples = jobExamples.filter((item) => item.id !== deleteId);
      allExamples = allExamples.filter((item) => item.id !== deleteId);
      renderJobExamples(allExamples);
      return;
    }

    $("#deleteExampleName").text(name);
    deleteModal.show();
  }

  $(document).on("click", ".delete-example-btn", function (e) {
    e.stopPropagation();
    openDeleteModal.call(this);
  });

  // Удаление примера
  function deleteExample() {
    console.log(deleteId);

    if (!deleteId) return;

    $.ajax({
      url: "/api/examples/" + deleteId,
      method: "DELETE",
      headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
      },
      success: function () {
        allExamples = allExamples.filter((item) => item.id !== deleteId);
        deleteModal?.hide();
        deleteId = null;
        renderJobExamples(allExamples);
        Toastify({
          text: "Пример работы успешно удалён!",
          gravity: "bottom",
          position: "right",
          duration: 3000,
        }).showToast();
      },
      error: function () {
        alert("Ошибка при удалении");
      },
    });
  }

  $("#confirmDeleteBtn")?.on("click", deleteExample);

  $(".example-file-trigger").on("click", function () {
    jobFiles.browse(); // 🔥 открывает системное окно выбора файла
  });

  // Добавление нового примера
  function addJobExample() {
    const id = Date.now() + Math.floor(Math.random() * 1000);

    const exampleObj = {
      id,
      name: $("#job_name").val(),
      description: $("#job_description").val(),
      category: $("#job_category").val(),
      price: $("#job_price").val(),
      files: jobFiles.getFiles(),
    };

    let formData = new FormData();
    formData.append("_token", $("#csrf-token").val());
    formData.append("workshop_id", $("#workshop_id").val());
    formData.append("name", exampleObj.name);
    formData.append("description", exampleObj.description);
    formData.append("category_id", exampleObj.category);
    formData.append("price", exampleObj.price);

    for (let i = 0; i < exampleObj.files.length; i++) {
      formData.append("files[]", exampleObj.files[i].file);
    }

    $.ajax({
      url: "/api/examples",
      type: "POST",
      data: formData,
      contentType: false,
      processData: false,
      success: function (response) {
        // если сервер вернул реальный id — перезапишем
        exampleObj.id = response.id ?? exampleObj.id;

        allExamples.push(exampleObj);
        renderJobExamples(allExamples);

        // Очистка формы
        $("#job_name, #job_description, #job_price").val("");
        $("#job_category").val("");
        jobFiles.removeFiles();

        Modal.getInstance($("#addJob")).hide();

        Toastify({
          text: "Пример работы успешно добавлен!",
          gravity: "bottom",
          position: "right",
          duration: 3000,
        }).showToast();
      },
      error: function () {
        Toastify({
          text: "Ошибка при добавлении примера",
          gravity: "bottom",
          position: "right",
          duration: 3000,
        }).showToast();
      },
    });
  }

  $(".addJob__save").on("click", function (e) {
    e.preventDefault();
    const form = $("#addJobForm");

    if (form.valid()) {
      addJobExample();
    }
  });

  const editJob = document.getElementById("editJob");

  // --- 1. Инициализация FilePond ---
  const editPond = FilePond.create(document.querySelector("#edit_job_files"), {
    allowMultiple: true,
    credits: false,
    server: {
      process: (fieldName, file, metadata, load, error, progress, abort) => {
        const formData = new FormData();
        formData.append("videoUrls[]", file); // кладем сам файл
        formData.append("ownerid", $("#example_id").val());
        formData.append("_token", $("#csrf-token").val());
        formData.append("acc", "add");
        formData.append("type", "example");

        $.ajax({
          url: "/api/files",
          method: "PATCH",
          data: formData,
          processData: false,
          contentType: false,
          xhr: () => {
            const xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener("progress", (e) => {
              if (e.lengthComputable) {
                progress(e.lengthComputable, e.loaded, e.total);
              }
            });
            return xhr;
          },
          success: (res) => {
            load(res.result); // serverId — путь/имя файла
          },
          error: (xhr) => {
            console.error(xhr.responseText);
            error("Ошибка загрузки");
            abort();
          },
        });

        return {
          abort: () => {
            abort();
          },
        };
      },
      revert: (uniqueFileId, load, error) => {
        // Для новых фото FilePond отдаст serverId (строка)
        $.ajax({
          url: "/api/files",
          method: "PATCH",
          data: { file: uniqueFileId },
          success: () => load(),
          error: (xhr) => {
            console.error(xhr.responseText);
            error("Ошибка удаления");
          },
        });
      },
    },
    onremovefile: (error, file) => {
      const exampleId = $("#example_id").val();
      if (!exampleId) return; // пример ещё не сохранён
      if (file.serverId) {
        // Это старый файл, удаляем по URL
        $.ajax({
          url: "/api/files",
          method: "PATCH",
          data: {
            videoUrls: [file.source],
            _token: $("#csrf-token").val(),
            ownerid: exampleId,
            acc: "delete",
            type: "example",
          }, // передаем URL старой фотки
          success: () => console.log("Удалено:", file.source),
          error: (xhr) =>
            console.error("Ошибка удаления старого файла:", xhr.responseText),
        });
      }
    },
  });

  // --- 2. Подгрузка данных в модалку ---
  $("#editJob").on("show.bs.modal", function (event) {
    const button = $(event.relatedTarget);
    const exampleId = button.data("id");

    const form = $("#editJobForm");
    form.attr("action", `/api/examples/${exampleId}`);
    $("#example_id").val(exampleId);

    // очищаем фото-блок
    const photosWrapper = form.find(".job-photos-wrapper");
    photosWrapper.find(".job-photo").remove();

    // ✅ сброс фото
    examplePhotos = [];

    $.get(`/api/examples/${exampleId}`, function (res) {
      if (!res?.result) return;

      const data = res.result;

      // --- ТЕКСТОВЫЕ ПОЛЯ ---
      $("#edit_job_name").val(data.name);
      $("#edit_job_description").val(data.description);
      $("#edit_job_price").val(data.price);

      // --- КАТЕГОРИЯ (кастомный dropdown) ---
      const dropdown = form.find(".dropdown");
      const dropdownHeader = dropdown.find(".dropdown__header span");
      const dropdownInput = dropdown.find('input[name="job_category"]');
      const dropdownItems = dropdown.find(".dropdown__body .item");

      const categoryId = data.category_id;
      const categoryItem = dropdownItems.filter(`[data-key="${categoryId}"]`);

      if (categoryItem.length) {
        dropdownHeader.text(categoryItem.text());
        dropdownHeader[0].dataset.key = categoryId;
        dropdownInput.val(categoryId).trigger("change");
      }

      // --- ФОТОГРАФИИ ---
      try {
        const filesData = JSON.parse(data.files || "{}");
        const photos = filesData?.result || [];

        photos.forEach((photo) => {
          examplePhotos.push(photo);
          renderPhoto(photo);
        });
      } catch (e) {
        console.error("Ошибка парсинга files:", e);
      }
    });
  });

  // --- 3. Отправка формы ---
  $("#editJobForm").on("submit", function (e) {
    e.preventDefault();

    const form = $(this)[0];
    const url = $(this).attr("action");
    const formData = new FormData(form);

    // Собираем список файлов
    const files = editPond.getFiles().map((file) => {
      if (file.serverId) {
        return file.serverId; // новые файлы (загруженные)
      }
      if (file.origin === FilePond.FileOrigin.LOCAL) {
        // старые файлы → просто возвращаем имя/ссылку
        return file.source.replace(/^.*[\\/]/, "");
      }
    });

    // formData.append('files', JSON.stringify(files));

    $.ajax({
      url: url,
      method: "PATCH", // Laravel примет @method('PUT')
      data: formData,
      processData: false,
      contentType: false,
      success: function (res) {
        if (res.result) {
          Modal.getOrCreateInstance(editJob).hide();
          getWorkshopExamples();
          // TODO: обновить список примеров
        }
      },
      error: function (xhr) {
        console.error(xhr.responseJSON);
        alert("Ошибка при сохранении!");
      },
    });
  });

  $("#addJobPhoto").on("click", function () {
    $("#editPhotoInput").click();
  });

  /** ✅ ХЕЛПЕР: достаём files.result из твоего ответа { example: { [id]: { files: "json" } } } */
  function extractExampleFilesFromResponse(res, exampleId) {
    try {
      const ex = res?.example?.[exampleId] || res?.example?.[String(exampleId)];
      if (!ex?.files) return [];
      const parsed = typeof ex.files === "string" ? JSON.parse(ex.files) : ex.files;
      return parsed?.result || [];
    } catch (e) {
      console.error("extractExampleFilesFromResponse error:", e, res);
      return [];
    }
  }

  /**
   * ✅ ИЗМЕНЕНО: добавление фото
   * - сразу рисуем локальное превью
   * - после ответа сервера получаем актуальный список из res.example[id].files
   * - берём последнее добавленное, подменяем превью, ставим кнопку удаления
   */
  $("#editPhotoInput").on("change", function () {
    const files = this.files;
    const exampleId = $("#example_id").val();
    if (!exampleId || !files?.length) return;

    Array.from(files).forEach((file) => {
      const tempEl = renderTempPhoto(file);

      addPhoto(file, exampleId)
        .then((res) => {
          const list = extractExampleFilesFromResponse(res, exampleId);
          const uploadedPath = list[list.length - 1];
          if (!uploadedPath) throw new Error("Upload failed");

          // сервер — источник истины
          examplePhotos = list;

          finalizeTempPhoto(tempEl, uploadedPath);

          Toastify({
            text: "Фото добавлено",
            gravity: "bottom",
            position: "right",
            duration: 2000,
          }).showToast();
        })
        .catch((err) => {
          console.error(err);
          tempEl.remove();

          Toastify({
            text: "Ошибка при загрузке фото",
            gravity: "bottom",
            position: "right",
            duration: 3000,
          }).showToast();
        });
    });

    $(this).val("");
  });

  /** ✅ временное превью */
  function renderTempPhoto(file) {
    const src = URL.createObjectURL(file);

    const photoEl = $(`
      <div class="position-relative w100px h100px border job-photo">
        <img src="${src}" class="w-100 h-100 object-fit-cover" />
        <div class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
             style="background: rgba(255,255,255,.65);">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </div>
    `);

    $(".job-photos-wrapper").append(photoEl);
    return photoEl;
  }

  /** ✅ превращаем temp -> серверное + кнопка удаления */
  function finalizeTempPhoto(tempEl, filePath) {
    tempEl.find(".spinner-border").closest("div").remove();
    tempEl.find("img").attr("src", `/upload/zakaz/${filePath}`);

    const btn = $(`
      <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0 remove-job-photo">&times;</button>
    `);

    btn.on("click", function () {
      deletePhoto(filePath, $("#example_id").val(), tempEl);
    });

    tempEl.append(btn);
  }

  function renderPhoto(filePath) {
    const photoEl = $(`
      <div class="position-relative w100px h100px border job-photo">
        <img src="/upload/zakaz/${filePath}" class="w-100 h-100 object-fit-cover" />
        <button type="button" class="btn btn-sm btn-danger position-absolute top-0 end-0 remove-job-photo">&times;</button>
      </div>
    `);

    photoEl.find(".remove-job-photo").on("click", function () {
      deletePhoto(filePath, $("#example_id").val(), photoEl);
    });

    $(".job-photos-wrapper").append(photoEl);
  }

  function addPhoto(file, exampleId) {
    const formData = new FormData();
    formData.append("id", exampleId);
    formData.append("model", "Example");
    formData.append("field", "files");
    formData.append("files[]", file);

    $(".loading").show();

    return fetch("/api/files", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .finally(() => $(".loading").hide());
  }

  /**
   * ✅ ИЗМЕНЕНО: удаление фото
   * - убираем из DOM сразу
   * - после ответа проверяем: исчез ли filePath из нового списка
   * - если не исчез → откат
   */
  function deletePhoto(filePath, exampleId, el) {
    if (!filePath || !exampleId) return;

    // optimistic UI
    el.remove();

    const prevPhotos = [...examplePhotos];

    fetch("/api/files", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: exampleId,
        model: "Example",
        paths: [filePath],
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        const list = extractExampleFilesFromResponse(res, exampleId);

        const stillExists = list.includes(filePath);
        if (stillExists) {
          // откат
          examplePhotos = prevPhotos;
          renderPhoto(filePath);

          Toastify({
            text: "Не удалось удалить фото",
            gravity: "bottom",
            position: "right",
            duration: 3000,
          }).showToast();
          return;
        }

        examplePhotos = list;

        Toastify({
          text: "Фото удалено",
          gravity: "bottom",
          position: "right",
          duration: 2000,
        }).showToast();
      })
      .catch((err) => {
        console.error(err);

        // откат
        examplePhotos = prevPhotos;
        renderPhoto(filePath);

        Toastify({
          text: "Ошибка при удалении фото",
          gravity: "bottom",
          position: "right",
          duration: 3000,
        }).showToast();
      });
  }
}
